module.exports = __webpack_public_path__ + "fonts/LatoLatin-Regular.e406b2c.eot";